import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { DataStore, SortDirection } from "aws-amplify";
import Login from "../../setup/auth/login.component";
import { reactLocalStorage } from "reactjs-localstorage";
import landing_logo from "../../assets/images/landing_logo.png";
import arrowcircleright from "../../assets/images/arrowcircleright.svg";
import { Image } from "primereact/image";

import AccountSettings from "../../components/common/AccountSettings";

import { getUserPermissions } from "../../components/actions/userActions";
import { get_all_notifications } from "../../components/actions/notificationsGraphQLActions";

const AllApplicationDashboard = () => {
  const [isAuthenticated, userHasAuthenticated] = useState(true);

  let REACT_APP_Show_To_User = process.env.REACT_APP_Show_To_User;

  console.log('REACT_APP_Show_To_User', REACT_APP_Show_To_User)

  const [userAppPermissionList, setUserAppsPermissionList] = useState([]);
  const [weeklyAbsenceReportRoute, setWeeklyAbsenceReportRoute] = useState("");
  const [stipendReportRoute, setStipendReportRoute] = useState("");

  const [weeklyAbsenceCertifiedAdminRoute, setWeeklyAbsenceCertifiedAdminRoute] = useState("");
  const [employeeHandbookRoute, setEmployeeRoute] = useState("");

  const [sixPeriodIsSuperadmin, setSixPeriodIsSuperadmin] = useState(0);
  const loggedUserId = reactLocalStorage.get("loggedUserId");

  const [psaServiceARoute, setPsaServiceARoute] = useState("");
  const checkApplicationAccessibility = async () => {
    //validate weekly absence report validation
    let loggedUserRole = reactLocalStorage.get("loggedUserRole");
    let weeklyAbsenceRoute = "";
    let stipendRoute = "";

    let employeeHandbookRoute = "/employee-agreement-handbook";
    let psaServiceRoute = "/personalserviceagreement";

    if (loggedUserRole === "I") {
      weeklyAbsenceRoute = "/initiator/weekly_absence_report";
      employeeHandbookRoute = "/employee-handbook";
      stipendRoute = "/initiator/stipend_form";

    } else if (loggedUserRole === "AP") {
      weeklyAbsenceRoute = "/approver/weekly_absence_report";
      //psaServiceRoute = "/approver/personalserviceagreement";
      stipendRoute = "/initiator/stipend_form";
    } else if (loggedUserRole === "P") {
      weeklyAbsenceRoute = "/payroll/weekly_absence_report";
      stipendRoute = "/payroll/stipend_list";
      //psaServiceRoute = "/payroll/personalserviceagreement";
    }

    setStipendReportRoute(stipendRoute);
    setWeeklyAbsenceReportRoute(weeklyAbsenceRoute);

    setEmployeeRoute(employeeHandbookRoute);
    setPsaServiceARoute(psaServiceRoute)

    //validate weekly absence report validation
    let weeklyAbsenceCertifiedAdminReport = reactLocalStorage.get("loggedUserRole");
    let weeklyAbsenceCertifiedAdminRoute = "";
    if (weeklyAbsenceCertifiedAdminReport === "I") {
      weeklyAbsenceCertifiedAdminRoute = "/initiator/weekly_absent_report_certificated_admin";
    } else if (weeklyAbsenceCertifiedAdminReport === "AP") {
      weeklyAbsenceCertifiedAdminRoute = "/approver/weekly_absent_report_certificated_admin";
    } else if (weeklyAbsenceCertifiedAdminReport === "P") {
      weeklyAbsenceCertifiedAdminRoute = "/payroll/weekly_absent_report_certificated_admin";
    }
    setWeeklyAbsenceCertifiedAdminRoute(weeklyAbsenceCertifiedAdminRoute);
    setSixPeriodIsSuperadmin(sixPeriodIsSuperadmin);
  };

  const appIds = ["WEEKLY_ABSENCE_REPORT",
    "WEEKLY_ABSENCE_REPORT_ADMIN",
    "TIME_REPORT",
    "SIX_PERIOD",
    "EMPLOYEE_HAND_BOOK",
    "CLASSIFIED_SUB_REQUEST",
    "SUBSTITUTE_REQUEST_CERTIFICATED",
    "STIPENDS_FORM",
    "PERSONAL_SERVICE_AGREEMENT",
    "PERSONNEL_ACTION_FORM"]

  const [notificationData, setNotificationData] = useState({
    "WEEKLY_ABSENCE_REPORT": { read: 0, unread: 0 },
    "WEEKLY_ABSENCE_REPORT_ADMIN": { read: 0, unread: 0 },
    "TIME_REPORT": { read: 0, unread: 0 },
    "SIX_PERIOD": { read: 0, unread: 0 },
    "EMPLOYEE_HAND_BOOK": { read: 0, unread: 0 },
    "CLASSIFIED_SUB_REQUEST": { read: 0, unread: 0 },
    "SUBSTITUTE_REQUEST_CERTIFICATED": { read: 0, unread: 0 },
    "STIPENDS_FORM": { read: 0, unread: 0 },
    "PERSONAL_SERVICE_AGREEMENT": { read: 0, unread: 0 },
    "PERSONNEL_ACTION_FORM": { read: 0, unread: 0 }
  });

  const permissionsTileInfoDic = {
    WEEKLY_ABSENCE_REPORT: { link: weeklyAbsenceReportRoute, title: 'Weekly Absence Report-Classified' },
    WEEKLY_ABSENCE_REPORT_ADMIN: { link: weeklyAbsenceCertifiedAdminRoute, title: 'Weekly Absence Report Certificated Admin' },
    TIME_REPORT: { link: '/time_report', title: 'Time Report' },
    SIX_PERIOD: { link: '/sixth_period_report_list', title: '6th Period Teaching Assignment' },
    EMPLOYEE_HAND_BOOK: { link: employeeHandbookRoute, title: 'Employee Handbook 2022-23' },
    CLASSIFIED_SUB_REQUEST: { link: '/initiator/substituteRequestClassified', title: 'Substitute Request - Classified' },
    SUBSTITUTE_REQUEST_CERTIFICATED: { link: '/substitute_request_certificated', title: 'Substitute Request Certificated' },
    PERSONNEL_ACTION_FORM: { link: '/initiator/initiatereportlist', title: 'Personnel Action' },
    PERSONAL_SERVICE_AGREEMENT: { link: psaServiceARoute, title: 'Personal Services Agreement' },
    STIPENDS_FORM: { link: stipendReportRoute, title: 'Stipends Form' }
  }

  const getUnreadNotificationCount = async (userId) => {
    try {

      const notifications = await get_all_notifications(userId, 'APP');
      const unreadNotifications = notifications.filter((notification) => notification.read_at === null);
      const notificationsTempData = { ...notificationData }

      appIds.map((appId) => {
        const appUnreadNotifications = unreadNotifications.filter((notifications) => notifications.AppId === appId);
        notificationsTempData[appId] = { read: 0, unread: appUnreadNotifications?.length };
      })
      setNotificationData(notificationsTempData);

    } catch (error) {
      console.error('Error fetching unread notification count:', error);
    }
  };

  const getUserAppsPermission = async (userId) => {
    try {
      const permissions = await getUserPermissions(userId);

        //item.UserId === 'dd16c7d8-289d-43c8-b01e-7f70de067282' || 

        let filteredArray = permissions.filter(item => {
          if (REACT_APP_Show_To_User === 'true') {
            if (item.AppId === 'PERSONAL_SERVICE_AGREEMENT') {
              if (item.UserId === '111be5e0-50d1-708b-aac1-92eb2d6b7a19' || item.UserId === 'f15bf560-9021-7087-f4af-e46f711e3cff' || item.UserId === '415b15f0-2071-70e1-8f08-533596198c49' || item.UserId === 'b8f9e4f1-8eb3-4250-8f92-2fe6438ac9c7' || item.UserId === '9490d71f-9892-44e2-a964-2f421a0873ae' || item.UserId === '7f11c8d4-2aa3-46a0-be75-b9fdfba79db9' || item.UserId === '22203577-6a0e-4dc4-91a9-26e712202234' || item.UserId === '775f5b15-bf1e-4720-824a-5a654d198a6d' || item.UserId === '8bfc4ff7-dc66-4304-a23f-4f84d5739664' || item.UserId === '01db65e0-7001-70c9-2c4a-caeee8b8d553' || item.UserId === 'c16bb530-3071-70fd-2fb5-1adfe88e2c25' || item.UserId === 'c1ebe570-30c1-70be-f067-f4b881aba600' || item.UserId === 'f17b05d0-7081-70d4-ffce-f5e4cc8799db' || item.UserId === 'a12b9590-70f1-7089-0653-4c4df66f3fc1' || item.UserId === '81eba5c0-40e1-70df-3648-6cc931ee5c8f' || item.UserId === 'e16ba560-5011-7071-0509-493013d01402' || item.UserId === 'a13b9530-10f1-7049-82df-194987073a13' ||
              item.UserId === '311b9570-8001-70a9-a22b-3d6e8f985ffa' || item.UserId === '01eb0560-b031-7032-d2a0-9cf0bde03a35' || item.UserId === 'f1db65a0-c031-706e-ff32-91ec7c6590b1' || item.UserId === '71db95d0-a0c1-70bc-7cf6-b162c0af869c' || item.UserId === '817b75e0-50a1-705a-52c2-9bb24929afaa' || item.UserId === '118b6580-5011-7052-1401-02323a0a78e4' || item.UserId === '411b8530-b061-70a6-2665-f29dc1bac1f4' || item.UserId === '015b0550-c0e1-7050-8603-a19397db9110' || item.UserId === '41aba590-60e1-70ae-e7e7-263a1223d27e' || item.UserId === '214b1530-b081-70cc-5b6c-b5b09e56a84f' || item.UserId === 'f12ba510-6011-7028-19a3-453145c79ae7' || item.UserId === '311ba5c0-c0b1-701c-88f3-7160dbb45ae1' || item.UserId === 'c16b8510-7091-7039-2c8b-93343b5f57c7' || item.UserId === 'a1ab3590-0011-70cb-6dba-731b4a5e2948' || item.UserId === '812bc5a0-90f1-7027-e3f3-a5f3139f4b50') {
                return true;
              } else {
                return false;
              }
            }
            else if (item.AppId === 'STIPENDS_FORM') {
              if (item.UserId === '111be5e0-50d1-708b-aac1-92eb2d6b7a19' || item.UserId === 'f15bf560-9021-7087-f4af-e46f711e3cff' || item.UserId === '415b15f0-2071-70e1-8f08-533596198c49' || item.UserId === 'b8f9e4f1-8eb3-4250-8f92-2fe6438ac9c7' || item.UserId === '9490d71f-9892-44e2-a964-2f421a0873ae' || item.UserId === '7f11c8d4-2aa3-46a0-be75-b9fdfba79db9' || item.UserId === '22203577-6a0e-4dc4-91a9-26e712202234' || item.UserId === '775f5b15-bf1e-4720-824a-5a654d198a6d' || item.UserId === '8bfc4ff7-dc66-4304-a23f-4f84d5739664' || item.UserId === '01db65e0-7001-70c9-2c4a-caeee8b8d553' || item.UserId === 'c16bb530-3071-70fd-2fb5-1adfe88e2c25' || item.UserId === 'c1ebe570-30c1-70be-f067-f4b881aba600' || item.UserId === 'f17b05d0-7081-70d4-ffce-f5e4cc8799db' || item.UserId === 'a12b9590-70f1-7089-0653-4c4df66f3fc1' || item.UserId === '81eba5c0-40e1-70df-3648-6cc931ee5c8f' || item.UserId === 'e16ba560-5011-7071-0509-493013d01402' || item.UserId === 'a13b9530-10f1-7049-82df-194987073a13' ||
              item.UserId === '311b9570-8001-70a9-a22b-3d6e8f985ffa' || item.UserId === '01eb0560-b031-7032-d2a0-9cf0bde03a35' || item.UserId === 'f1db65a0-c031-706e-ff32-91ec7c6590b1' || item.UserId === '71db95d0-a0c1-70bc-7cf6-b162c0af869c' || item.UserId === '817b75e0-50a1-705a-52c2-9bb24929afaa' || item.UserId === '118b6580-5011-7052-1401-02323a0a78e4' || item.UserId === '411b8530-b061-70a6-2665-f29dc1bac1f4' || item.UserId === '015b0550-c0e1-7050-8603-a19397db9110' || item.UserId === '41aba590-60e1-70ae-e7e7-263a1223d27e' || item.UserId === '214b1530-b081-70cc-5b6c-b5b09e56a84f' || item.UserId === 'f12ba510-6011-7028-19a3-453145c79ae7' || item.UserId === '311ba5c0-c0b1-701c-88f3-7160dbb45ae1' || item.UserId === 'c16b8510-7091-7039-2c8b-93343b5f57c7' || item.UserId === 'a1ab3590-0011-70cb-6dba-731b4a5e2948' || item.UserId === '812bc5a0-90f1-7027-e3f3-a5f3139f4b50') {
                return true;
              } else {
                return false;
              }
            }
            else if (item.AppId === 'PERSONNEL_ACTION_FORM') {
              if (item.UserId === '111be5e0-50d1-708b-aac1-92eb2d6b7a19' || item.UserId === 'f15bf560-9021-7087-f4af-e46f711e3cff' || item.UserId === '415b15f0-2071-70e1-8f08-533596198c49' || item.UserId === 'b8f9e4f1-8eb3-4250-8f92-2fe6438ac9c7' || item.UserId === '9490d71f-9892-44e2-a964-2f421a0873ae' || item.UserId === '7f11c8d4-2aa3-46a0-be75-b9fdfba79db9' || item.UserId === '22203577-6a0e-4dc4-91a9-26e712202234' || item.UserId === '775f5b15-bf1e-4720-824a-5a654d198a6d' || item.UserId === '8bfc4ff7-dc66-4304-a23f-4f84d5739664' || item.UserId === '01db65e0-7001-70c9-2c4a-caeee8b8d553' || item.UserId === 'c16bb530-3071-70fd-2fb5-1adfe88e2c25' || item.UserId === 'c1ebe570-30c1-70be-f067-f4b881aba600' || item.UserId === 'f17b05d0-7081-70d4-ffce-f5e4cc8799db' || item.UserId === 'a12b9590-70f1-7089-0653-4c4df66f3fc1' || item.UserId === '81eba5c0-40e1-70df-3648-6cc931ee5c8f' || item.UserId === 'e16ba560-5011-7071-0509-493013d01402' || item.UserId === 'a13b9530-10f1-7049-82df-194987073a13' ||
              item.UserId === '311b9570-8001-70a9-a22b-3d6e8f985ffa' || item.UserId === '01eb0560-b031-7032-d2a0-9cf0bde03a35' || item.UserId === 'f1db65a0-c031-706e-ff32-91ec7c6590b1' || item.UserId === '71db95d0-a0c1-70bc-7cf6-b162c0af869c' || item.UserId === '817b75e0-50a1-705a-52c2-9bb24929afaa' || item.UserId === '118b6580-5011-7052-1401-02323a0a78e4' || item.UserId === '411b8530-b061-70a6-2665-f29dc1bac1f4' || item.UserId === '015b0550-c0e1-7050-8603-a19397db9110' || item.UserId === '41aba590-60e1-70ae-e7e7-263a1223d27e' || item.UserId === '214b1530-b081-70cc-5b6c-b5b09e56a84f' || item.UserId === 'f12ba510-6011-7028-19a3-453145c79ae7' || item.UserId === '311ba5c0-c0b1-701c-88f3-7160dbb45ae1' || item.UserId === 'c16b8510-7091-7039-2c8b-93343b5f57c7' || item.UserId === 'a1ab3590-0011-70cb-6dba-731b4a5e2948' || item.UserId === '812bc5a0-90f1-7027-e3f3-a5f3139f4b50' || item.UserId === '01c6f376-c220-423e-ae34-b109567a817f') {
                return true;
              } else {
                return false;
              }
            }
            else if (item.AppId === 'SIX_PERIOD') {
              if (item.UserId === '111be5e0-50d1-708b-aac1-92eb2d6b7a19' || item.UserId === 'f15bf560-9021-7087-f4af-e46f711e3cff' || item.UserId === '415b15f0-2071-70e1-8f08-533596198c49' || item.UserId === 'b8f9e4f1-8eb3-4250-8f92-2fe6438ac9c7' || item.UserId === '9490d71f-9892-44e2-a964-2f421a0873ae' || item.UserId === '7f11c8d4-2aa3-46a0-be75-b9fdfba79db9' || item.UserId === '22203577-6a0e-4dc4-91a9-26e712202234' || item.UserId === '775f5b15-bf1e-4720-824a-5a654d198a6d' || item.UserId === '8bfc4ff7-dc66-4304-a23f-4f84d5739664' || item.UserId === '01db65e0-7001-70c9-2c4a-caeee8b8d553' || item.UserId === 'c16bb530-3071-70fd-2fb5-1adfe88e2c25' || item.UserId === 'c1ebe570-30c1-70be-f067-f4b881aba600' || item.UserId === 'f17b05d0-7081-70d4-ffce-f5e4cc8799db' || item.UserId === 'a12b9590-70f1-7089-0653-4c4df66f3fc1' || item.UserId === '81eba5c0-40e1-70df-3648-6cc931ee5c8f' || item.UserId === 'e16ba560-5011-7071-0509-493013d01402' || item.UserId === 'a13b9530-10f1-7049-82df-194987073a13' ||
              item.UserId === '311b9570-8001-70a9-a22b-3d6e8f985ffa' || item.UserId === '01eb0560-b031-7032-d2a0-9cf0bde03a35' || item.UserId === 'f1db65a0-c031-706e-ff32-91ec7c6590b1' || item.UserId === '71db95d0-a0c1-70bc-7cf6-b162c0af869c' || item.UserId === '817b75e0-50a1-705a-52c2-9bb24929afaa' || item.UserId === '118b6580-5011-7052-1401-02323a0a78e4' || item.UserId === '411b8530-b061-70a6-2665-f29dc1bac1f4' || item.UserId === '015b0550-c0e1-7050-8603-a19397db9110' || item.UserId === '41aba590-60e1-70ae-e7e7-263a1223d27e' || item.UserId === '214b1530-b081-70cc-5b6c-b5b09e56a84f' || item.UserId === 'f12ba510-6011-7028-19a3-453145c79ae7' || item.UserId === '311ba5c0-c0b1-701c-88f3-7160dbb45ae1' || item.UserId === 'c16b8510-7091-7039-2c8b-93343b5f57c7' || item.UserId === 'a1ab3590-0011-70cb-6dba-731b4a5e2948' || item.UserId === '812bc5a0-90f1-7027-e3f3-a5f3139f4b50') {
                return true;
              } else {
                return false;
              }
            }
            return true;
          } else {
            return true;
          }
        })

        const uniquePermissions = filteredArray?.reduce((accumulator, permission) => {

          const existingPermission = accumulator.find(p => p.AppId === permission.AppId);
          console.log('existingPermission', existingPermission)

          if (!existingPermission) {
            accumulator.push(permission);
          }
          return accumulator;
        }, []);

        setUserAppsPermissionList(uniquePermissions);
      } catch (error) {
        console.error('Error fetching User Apps Permission:', error);
      }
    }

  useEffect(() => {
      if (localStorage.getItem("loggedUserId") === null) {
        userHasAuthenticated(false);
      } else {
        getUnreadNotificationCount(loggedUserId);
        getUserAppsPermission(loggedUserId);
        checkApplicationAccessibility();
      }
    }, []);


    const getNotifications = async () => {
      await getUnreadNotificationCount(loggedUserId);
    }

    useEffect(() => {
      const intervalId = setInterval(getNotifications, 30000); // 30 seconds in milliseconds
      return () => {
        clearInterval(intervalId);
      };
    }, []);


    const getTile = (appId) => {

      if (!appId) {
        return null;
      }

      return (
        <div>
          <Link to={permissionsTileInfoDic[appId]?.link}>
            <div className="bg-[#F9FBFF] xl:p-[1.250vw] p-[20px] box-shadow rounded-lg relative xl:h-[8.833vw] h-[160px]">
              <h4 className="text-[#011834] text-[20px] xl:text-[1vw] md:text-[1.5vw] font-medium leading-tight flex items-center xl:h-[4.167vw] h-[80px]">
                {permissionsTileInfoDic[appId]?.title}
              </h4>
              <div className="flex items-center gap-2 xl:mt-[1.042vw] mt-[18px]">
                <img
                  src={arrowcircleright}
                  width={24}
                  height={24}
                  className="rounded-full xl:w-[1.250vw] xl:h-[1.250vw]"
                  alt="Arrow"
                />
                <p className="text-[#1262D0] text-[20px] xl:text-[0.781vw] md:text-[1.5vw] font-medium">Run</p>
              </div>
              {/* Move the inner Link content outside */}
              <div className="text-[#011834] font-semibold absolute bottom-0 right-0 text-right alert-bg-warp">
                <div className="absolute bottom-2 right-3">
                  <p className="text-base">{notificationData[appId]?.unread || 0}</p>
                  <p className="text-[10px] font-semibold">Alerts</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
      )
    }

    return isAuthenticated ? (
      <>
        <div className="h-screen bg-landing">
          <div className="xl:px-[1.042vw] 2xl:px-[1.042vw] px-[20px]">
            <div className="w-full z-20 header-wrap">
              <div className="">
                <div className=" py-[0.500vw] relative z-20">
                  <div
                    className="px-[15px] xl:px-[3.125vw] py-[12px] xl:py-[0.625vw]"
                    data-aos="fade-down"
                    data-aos-duration="700"
                    data-aos-delay="500"
                  >
                    <div className="flex items-center justify-end">
                      <div className="flex items-center  gap-x-[20px] lg:gap-x-[40px] xl:gap-x-[0.683vw]">
                        <AccountSettings />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="xl:px-[2.042vw] 2xl:px-[2.042vw] px-[20px] xl:pt-[3.292vw] pt-[80px]">
              <div>
                <Image
                  src={landing_logo}
                  width={"120"}
                  height={"120"}
                  imageClassName="rounded-full w-[120px] h-[120px] xl:w-[7.292vw] xl:h-[7.292vw]"
                />

                <div className="xl:mt-[0.900vw] mt-[20px]">
                  <h6 className="text-[#344054] text-[28px] xl:text-[1.5vw] font-light leading-tight">Welcome to </h6>
                  <h1 className="text-[#002870] text-[50px] xl:text-[2.5vw] font-extrabold leading-tight"><span className="text-[#101828] font-normal">GUSD</span>  Forms</h1>
                </div>
              </div>

              <div className="grid grid-cols-12 md:grid-cols-12 xl:grid-cols-12 2xl:grid-cols-12 lg:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5 xl:mt-[1.250vw] mt-[20px]">
                <div className="col-span-12 xl:col-span-9 2xl:col-span-9 md:col-span-12">
                  <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-3 xl:gap-[1vw]">
                    {userAppPermissionList.map(({ AppId }) => getTile(AppId))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <Login sessionExpired={1} />
    );
  };

  export default AllApplicationDashboard;
